import moment from "moment";
import { GiSettingsKnobs } from "react-icons/gi";
import {
  Checkbox,
  DatePicker,
  DateRangePicker,
  CheckPicker,
  SelectPicker,
} from "rsuite";

import { Locale } from "./constants";

import ButtonIcon from "../../../../components/ButtonIcon";
import TutoSpeechBubble from "../../../../components/TutoSpeechBubble";
import UserTagPicker from "../../../../components/User/UserTagPicker";

import parkinsonTypes from "../../constants/parkinsonTypes";

export default function TablePatientFilters({
  className,
  isLoading,
  tutoMode,
  onRemovePrescriber,
  onSearchPrescribers,
  onChangePrescriber,
  searchByPrescriber,
  filters,
  handleFilters,
  handleRemoveFilter,
  handleRemoveAllFilters,
  prescriberItems,
  prestations,
  searchByRenewalStatus,
  firstLogin,
  onRemovePatient,
  onSearchPatients,
  onChangePatient,
  searchByPatient,
  patientItems,
  onRemovePrestation,
  onSearchPrestations,
  onChangePrestation,
  searchByPrestation,
  prestationItems,
}) {
  const { afterToday } = DateRangePicker;
  return (
    <div
      id="filter"
      className={`bg-white rounded-lg shadow-xl h-fit lg:max-w-[250px] ${
        isLoading ? "pointer-events-none" : ""
      } ${className}`}
    >
      <div className="flex flex-row items-center gap-2 px-3 py-2 font-semibold text-white rounded-t-lg bg-primary">
        <GiSettingsKnobs size={12} className="rotate-90" />
        Filtrer
      </div>
      <div
        className={`flex flex-col p-3 gap-2 ${
          tutoMode ? "pointer-events-none" : ""
        }`}
      >
        {searchByPatient ? (
          <>
            <label className="text-xs font-semibold text-neutral-dark">
              Patient
            </label>
            <UserTagPicker
              placeholder="Filtrer par patient"
              value={patientItems}
              disabled={prescriberItems.length ? true : false}
              onClose={async (removedItem) =>
                await onRemovePatient(removedItem)
              }
              onSearch={async (word) => await onSearchPatients(word)}
              onChanged={async (value = []) => await onChangePatient(value)}
            />
          </>
        ) : null}
        {searchByPrescriber ? (
          <>
            <label className="text-xs font-semibold text-neutral-dark">
              Prescripteurs
            </label>
            <UserTagPicker
              placeholder="Filtrer par prescripteur"
              value={prescriberItems}
              disabled={patientItems.length ? true : false}
              onClose={async (removedItem) =>
                await onRemovePrescriber(removedItem)
              }
              onSearch={async (word) => await onSearchPrescribers(word)}
              onChanged={async (value = []) => await onChangePrescriber(value)}
            />
          </>
        ) : null}
        {searchByPrestation ? (
          <div className="flex flex-col gap-1">
            <span className="text-xs font-semibold text-neutral-dark">
              Prestations
            </span>
            <SelectPicker
              data={prestations}
              placeholder="Filtrer par prestation"
              size="sm"
              disabled={patientItems.length ? true : false}
              defaultValue={null}
              placement="bottomStart"
              block
              searchable={false}
              value={
                filters?.and?.find(
                  (filter) =>
                    filter["contract.plan.id"] !== undefined &&
                    filter["contract.plan.id"].$eq !== undefined
                )?.["contract.plan.id"].$eq ?? null
              }
              onChange={async (value) => {
                value
                  ? await handleFilters(
                      "and",
                      "contract.plan.id",
                      "$eq",
                      value ? Number(value) : null
                    )
                  : await handleRemoveFilter("and", "contract.plan.id", "$eq");
              }}
            />
          </div>
        ) : null}
        <div>
          <label className="mb-1 text-xs font-semibold text-neutral-dark">
            Date prestation:
          </label>
          <div className="mb-2">
            <span className="text-xs text-primary">Installé depuis le :</span>
            <DatePicker
              locale={Locale}
              format="dd/MM/yyyy"
              placeholder="Choisir une date"
              size="sm"
              shouldDisableDate={afterToday()}
              block
              value={
                filters?.and?.find(
                  (filter) =>
                    filter["firstContract.startDate"] !== undefined &&
                    filter["firstContract.startDate"].$gte !== undefined
                )?.["firstContract.startDate"].$gte ?? null
              }
              onChange={async (value) =>
                value
                  ? await handleFilters(
                      "and",
                      "firstContract.startDate",
                      "$gte",
                      value
                    )
                  : await handleRemoveFilter(
                      "and",
                      "firstContract.startDate",
                      "$gte"
                    )
              }
            />
          </div>
          <div>
            <span className="text-xs text-primary">Installé avant le :</span>
            <DatePicker
              locale={Locale}
              format="dd/MM/yyyy"
              placeholder="Choisir une date"
              size="sm"
              defaultValue={null}
              shouldDisableDate={afterToday()}
              block
              value={
                filters?.and?.find(
                  (filter) =>
                    filter["firstContract.startDate"] !== undefined &&
                    filter["firstContract.startDate"].$lte !== undefined
                )?.["firstContract.startDate"].$lte ?? null
              }
              onChange={async (value) =>
                value
                  ? await handleFilters(
                      "and",
                      "firstContract.startDate",
                      "$lte",
                      value
                    )
                  : await handleRemoveFilter(
                      "and",
                      "firstContract.startDate",
                      "$lte"
                    )
              }
            />
          </div>
        </div>

        <hr className="my-2" />

        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-neutral-dark">
            Type de Parkinson
          </span>
          <CheckPicker
            data={parkinsonTypes}
            placeholder="Choisir un type"
            size="sm"
            defaultValue={null}
            value={
              filters?.and?.find(
                (filter) =>
                  filter["parkinsonType.id"] !== undefined &&
                  filter["parkinsonType.id"].$in !== undefined
              )?.["parkinsonType.id"].$in ?? []
            }
            placement="bottomStart"
            block
            searchable={false}
            onChange={async (value) => {
              if (value.length) {
                await handleFilters("and", "parkinsonType.id", "$in", value);
              } else {
                await handleRemoveFilter("and", "parkinsonType.id", "$in");
              }
            }}
          />
        </div>

        <div className="mt-2">
          <Checkbox
            checked={
              filters?.and?.find(
                (filter) =>
                  filter["alert"] !== undefined &&
                  filter["alert"].$eq !== undefined
              )
                ? true
                : false
            }
            onChange={async (value, checked) => {
              checked
                ? await handleFilters("and", "alert", "$eq", true)
                : await handleRemoveFilter("and", "alert", "$eq");
            }}
          >
            <div className="text-xs font-bold text-primary">
              Patients en alerte
            </div>
          </Checkbox>
        </div>

        {searchByRenewalStatus ? (
          <div>
            <Checkbox
              checked={
                filters?.and?.find(
                  (filter) =>
                    filter["renewal.hasRenewal"] !== undefined &&
                    filter["renewal.hasRenewal"].$eq !== undefined
                )?.["renewal.hasRenewal"].$eq ?? false
              }
              onChange={async (value, checked) =>
                checked === true
                  ? await handleFilters(
                      "and",
                      "renewal.hasRenewal",
                      "$eq",
                      true
                    )
                  : await handleRemoveFilter("and", "renewal.hasRenewal", "$eq")
              }
            >
              <div className="text-xs font-bold text-primary">
                Prescription à renouveler
              </div>
              <TutoSpeechBubble
                text="Cette option permet de filtrer les patients en attente de renouvellement."
                isVisible={tutoMode}
                pointType="default"
                className="lg:block top-[130%] left-[25px] sm:top-[100%] sm:left-[15%]"
                pointPlacement="top-left"
              />
            </Checkbox>
          </div>
        ) : null}
        {firstLogin ? (
          <div>
            <Checkbox
              checked={
                filters?.and?.find(
                  (filter) =>
                    filter["lastIntervention.documents"] !== undefined &&
                    filter["lastIntervention.documents"].$elemMatch !==
                      undefined
                )
                  ? true
                  : false
              }
              onChange={async (value, checked) => {
                checked
                  ? await handleFilters(
                      "and",
                      "lastIntervention.documents",
                      "$elemMatch",
                      {
                        date: {
                          $gte: {
                            $date: `${moment(firstLogin).format(
                              "YYYY-MM-DD[T00:00:00.000Z]"
                            )}`,
                          },
                        },
                        importType: "Courrier",
                        firstReader: { $exists: false },
                      }
                    )
                  : await handleRemoveFilter(
                      "and",
                      "lastIntervention.documents",
                      "$elemMatch"
                    );
              }}
            >
              <div className="text-xs font-bold text-primary">CR non lu</div>
              <div className="text-xs tewt-secondary">
                {`Première connexion le ${moment(firstLogin).format(
                  "DD/MM/YYYY à HH:mm"
                )}`}
              </div>
            </Checkbox>
          </div>
        ) : null}
        <ButtonIcon
          className="w-full p-1 mt-2 text-white bg-primary hover:bg-light"
          text="Réinitialiser"
          textClassName=""
          style={{ borderRadius: 5 }}
          onClick={async () => await handleRemoveAllFilters()}
        />
      </div>
    </div>
  );
}
